// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#seriesRoot {
    position: relative;
    display: flex;

    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
}

#seriesParent {
    display: flex;
    flex-direction: column;
    aspect-ratio: 16/9;
    width: 100%;
    max-width: 177.778vh;
    max-height: 56.25vw;
    height: auto;
}

#interactionBlocker-SeriesSelection {
    position: absolute;
    width: 100vw;
    height: 100vh;

    z-index: 99;
}

.interactionBlockStart-SeriesSelection {
    animation-duration: 1.2s;
    animation-name: remove-blocker;
    animation-fill-mode: forwards;
}

.interactionBlockEnd-SeriesSelection {
    pointer-events: all;
}

#inputDiv1 {
    position: relative;
    height: 24.375%;
    
    /* Previous settings for thick black outline
    width: 98%;
    left: 1%;
    */

    margin-bottom: 0.5%;

    z-index: 3;

    animation-fill-mode: forwards;

    pointer-events: all;

    object-fit: contain;
    overflow: hidden;
}

#inputDiv2 {
    position: relative;

    height: 24.375%;

    margin-bottom: 0.5%;

    z-index: 2;

    animation-fill-mode: forwards;
    animation-delay: 0.4s;

    pointer-events: all;

    overflow: hidden;
}

#inputDiv3 {
    position: relative;

    height: 24.375%;

    margin-bottom: 0.5%;

    z-index: 1;

    animation-fill-mode: forwards;
    animation-delay: 0.8s;

    pointer-events: all;

    margin-left: 0%;

    overflow: hidden;
}

#inputDiv4 {
    position: relative;

    height: 24.375%;

    z-index: 0;

    animation-fill-mode: forwards;
    animation-delay: 1.2s;

    pointer-events: all;

    margin-left: 0%;

    overflow: hidden;
}

/* detail divs */
#detailsDiv1 {
    position: absolute;

    height:100%;
    width: 45%;

    z-index: 10;

    container-type: size;

    pointer-events: none;
    user-select: none;
}

#detailsDiv2 {
    position: absolute;

    height:100%;
    width: 45%;

    z-index: 10;

    container-type: size;

    pointer-events: none;
    user-select: none;

    /* justify-content: center; */
}

#detailsDiv4 {
    position: absolute;

    height:100%;
    width: 45%;

    z-index: 10;

    container-type: size;

    pointer-events: none;
    user-select: none;

    /* justify-content: center; */
}

#inputDiv1:hover > img {
    animation: initCarPunchout 0.5s normal 0.0s 1 forwards;
}

#inputDiv2:hover > img {
    animation: initCarPunchout 0.5s normal 0.0s 1 forwards;
}

#inputDiv3:hover > img {
    animation: initCarPunchout 0.5s normal 0.0s 1 forwards;
}

#inputDiv4:hover > img {
    animation: initCarPunchout 0.5s normal 0.0s 1 forwards;
}


.inputImage:not(:hover) {
    animation: exitCarPunchout 0.5s normal 0.0s 1 forwards;
}

/* Outlines */
.inputImage:not(:hover) {
    animation: exitCarPunchout 0.5s normal 0.0s 1 forwards;
}

#inputDiv1:hover > .outlineDiv {
    animation: fade-in 0.5s normal 0.0s 1 forwards;
}

#inputDiv2:hover > .outlineDiv {
    animation: fade-in 0.5s normal 0.0s 1 forwards;
}

#inputDiv3:hover > .outlineDiv {
    animation: fade-in 0.5s normal 0.0s 1 forwards;
}

#inputDiv4:hover > .outlineDiv {
    animation: fade-in 0.5s normal 0.0s 1 forwards;
}

.inputImage:not(:hover) ~ .outlineDiv {
    animation: fade-out1 0.3s normal 0.0s 1 forwards;
}

@keyframes initCarPunchout {
    from {
        transform: scale(100%);
    }

    to {
        transform: scale(110%);
    }
}

@keyframes exitCarPunchout {
    from {
        transform: scale(110%);
    }

    to {
        transform: scale(100%);
    }
}

.outlineDiv {
    position: absolute;
    height: 100%;
    width: 100%;

    z-index: 4;
    opacity: 0;

    border: 0.25cqw solid #ed9032;
}

/* text */

/* 1 */

/* "Series" text */
#detailsDiv1 h3 {
    position: absolute;

    left: 50%; 
    transform: translate(-50%);
    top: 23.5%;

    z-index: 5;
    font: 9.05cqh MyriadPro-Regular;
    font-weight: bold;
    color: rgb(97, 97, 97);
    text-transform: uppercase;
    letter-spacing: 0.5cqh;
}

#detailsDiv1 h2 {
    position: absolute;

    left: 50%;
    transform: translate(-50%);
    top: 31%;
    width: 65%;

    margin: 0px;

    z-index: 5;
    font: 23.5cqh Diesel;
    text-transform: uppercase;
    letter-spacing: 2cqh;
}

#detailsDiv1 div {
    position: relative;

    left: 0%;
    top: 60%;

    width: 100%;
    height: 100%;
}

#detailsDiv1 button {
    position: absolute;

    left: 50%;
    transform: translate(-50%);
    top: 80%;

    width: 18%;
    height: 12%;

    background-color: rgb(0, 0, 0);
    color: #e0e0df;

    z-index: 5;

    font: 5cqh MyriadPro-Bold;
    text-transform: uppercase;
    letter-spacing: 0.2cqh;
    font-weight: normal;
    line-height: 190%;

    padding: 0px, 0px, 0px, 0px;

    box-shadow: none;
    border-style: solid;
    border-radius: 25cqh;
    border-color: black;

    pointer-events: all;
}

#detailsDiv1 button:hover {
    /* transparent background */
    background-color: rgb(255, 255, 255, 0);
    color:black;
}

/*2 + 3*/

#detailsDiv2 h3 {
    position: absolute;

    left: 50%; 
    transform: translate(-50%);
    top: 10.5%;

    z-index: 5;
    font: 9.05cqh MyriadPro-Regular;
    font-weight: bold;
    color: rgb(97, 97, 97);
    text-transform: uppercase;
    letter-spacing: 0.5cqh;
}

#detailsDiv2 h2 {
    position: absolute;

    left: 50%;
    transform: translate(-50%);
    top: 16%;
    width: 90%;

    margin: 0px;

    z-index: 5;
    font: 30cqh Diesel;
    text-transform: uppercase;
    letter-spacing: 2cqh;

    text-align: center;
}

#detailsDiv2 div {
    position: relative;

    left: 0;
    top: 50%;

    width: 100%;
}

#detailsDiv2 button {
    position: absolute;

    left: 50%;
    transform: translate(-50%);
    top: 80%;

    width: 18%;
    height: 12%;

    background-color: rgb(0, 0, 0);
    color: #e0e0df;

    z-index: 5;

    font: 5cqh MyriadPro-Bold;
    text-transform: uppercase;
    letter-spacing: 0.2cqh;
    font-weight: normal;
    line-height: 190%;

    padding: 0px, 0px, 0px, 0px;

    box-shadow: none;
    border-style: solid;
    border-radius: 25cqh;
    border-color: black;

    pointer-events: all;
}

#detailsDiv2 button:hover {
    /* transparent background */
    background-color: rgb(255, 255, 255, 0);
    color:black;
}

/* 4 */

#detailsDiv4 h3 {
    position: absolute;

    left: 50%; 
    transform: translate(-50%);
    top: 10.5%;

    z-index: 5;
    font: 9.05cqh MyriadPro-Regular;
    font-weight: bold;
    color: rgb(97, 97, 97);
    text-transform: uppercase;
    letter-spacing: 0.5cqh;
}

#detailsDiv4 h2 {
    position: absolute;

    left: 50%;
    transform: translate(-50%);
    top: 16%;
    width: 90%;

    margin: 0px;

    z-index: 5;
    font: 30cqh Diesel;
    text-transform: uppercase;
    letter-spacing: 2cqh;

    text-align: center;
}

#detailsDiv4 div {
    position: relative;

    left: 0;
    top: 50%;

    width: 100%;
}

#detailsDiv4 button {
    position: absolute;

    left: 50%;
    transform: translate(-50%);
    top: 74%;

    width: 18%;
    height: 12%;

    background-color: rgb(0, 0, 0);
    color: #e0e0df;

    z-index: 5;

    font: 5cqh MyriadPro-Bold;
    text-transform: uppercase;
    letter-spacing: 0.2cqh;
    font-weight: normal;
    line-height: 190%;

    padding: 0px, 0px, 0px, 0px;

    box-shadow: none;
    border-style: solid;
    border-radius: 25cqh;
    border-color: black;

    pointer-events: all;
}



#detailsDiv4 button:hover {
    /* transparent background */
    background-color: rgb(255, 255, 255, 0);
    color:black;
}

.inputDiv-SeriesSelection-Intro {
    opacity: 0;

    animation-duration: 0.3s;
    animation-name: fade-in;
    animation-fill-mode: forwards;
}

.inputDiv-SeriesSelection-Outro {
    opacity: 1;

    animation-duration: 0.3s;
    animation-name: fade-out1;
    animation-fill-mode: forwards;
}

/* ---- */

#drawerHolder1_Series {
    position: absolute;

    top:0%;

    width: 100%;
    height: 100%;

    z-index: 5;
    clip-path: polygon(0% 0%, 83.8% 0%, 98.8% 50.6%, 84.6% 100.05%, 0% 100.05%);

    /* background-color: rgba(150, 0, 0, 0.5); */
}

#drawerContainer1_Series {
    display: relative;
    position: absolute;

    height: 100%;
    width: 100%;

    left: -26%;
    bottom: -90.8%;

    z-index: 5;

    pointer-events: all;
}

.drawer_open_series1 {
    animation: drawer_popup_series1 0.2s ease-in-out forwards;
}

.drawer_close_series1 {
    animation: drawer_collapse_series1 0.2s ease-in-out forwards;
}

@keyframes drawer_popup_series1 {
    from {
        bottom: -90.8%;
        left: -26%;
    }
    to {
        bottom: -66%;
        left: -22.5%;
    }
}

@keyframes drawer_collapse_series1 {
    from {
        bottom: -66%;
        left: -22.5%;
    }
    to {
        bottom: -90.8%;
        left: -26%;;
    }
}

#drawerHover1_Series {
    position: absolute;

    height: 100%;
    width: 100%;
    top: 0%;
    left: -42%;
    pointer-events: none;

    transition: top 0.2s ease-in-out;
}

#drawerHover1_Series:hover {
    top: -1%;
}

#drawer1_Series {
    width: auto;
    height: 37%;
}

.drawer_highlight_Series {
    position: absolute;

    left: 0%;

    width: auto;
    height: 30%;

    opacity: 0;
    -moz-opacity: 0;
    filter: alpha(opacity=0);
    z-index: 5;

    transition: opacity 0.5s 0.1s ease-in-out;
}

#optionsContainer2_series {
    position: absolute;

    width: 100%;
    height: 100%;

    left: 37.2%;
    top: 0%;

    container-type: size;
}

#optionsContainer2_series h2 {
    position: absolute;

    left: 58.2%;
    transform: translate(-50%);
    top: 1.9%;

    margin: 0px;

    z-index: 5;
    font: 4.9cqh Diesel;
    text-transform: uppercase;
}

#drawerHover2_Series {
    position: absolute;

    height: 100%;
    width: 100%;
    top: 0%;
    left: -29%;
    pointer-events: none;

    transition: top 0.2s ease-in-out;
}

#drawerHover2_Series:hover {
    top: -1%;
}

#optionsContainer2_series h3 {
    position: absolute;

    left: 57.9%; 
    transform: translate(-50%);
    top: 0.5%;

    z-index: 5;
    font: 2.05cqh MyriadPro-Regular;
    text-transform: uppercase;
    letter-spacing: 0.2cqh;
}

#drawerHover3_Series {
    position: absolute;

    height: 100%;
    width: 100%;
    top: 0%;
    left: -26%;
    pointer-events: none;

    transition: top 0.2s ease-in-out;
}

#drawerHover3_Series:hover {
    top: -1%;
}

#drawerHover4_Series {
    position: absolute;

    height: 100%;
    width: 100%;
    top: 0%;
    left: -26%;
    pointer-events: none;

    transition: top 0.2s ease-in-out;
}

#drawerHover4_Series:hover {
    top: -1%;
}

#drawerHolder2_Series {
    position: absolute;

    top:0%;

    width: 100%;
    height: 100%;

    z-index: 5;

    clip-path: polygon(0% 0%, 86.45% 0%, 98.8% 51%, 86.57% 100.05%, 0% 100.05%);

    /* background-color: rgba(0, 0, 150, 0.5); */
}

#drawerContainer2_Series {
    position: absolute;

    height: 100%;
    width: 100%;

    left: -18.5%;
    bottom: -90.8%;
    
    z-index: 5;

    pointer-events: all;
}

.drawer_open_series2 {
    animation: drawer_popup_series2 0.2s ease-in-out forwards;
}

.drawer_close_series2 {
    animation: drawer_collapse_series2 0.2s ease-in-out forwards;
}

@keyframes drawer_popup_series2 {
    from {
        bottom: -90.8%;
        left: -18.5%;
    }
    to {
        bottom: -66%;
        left: -13.5%;
    }
}

@keyframes drawer_collapse_series2 {
    from {
        bottom: -66%;
        left: -13.5%;
    }
    to {
        bottom: -90.8%;
        left: -18.5%;
    }
}

#drawer2_Series {
    height:37%;
    width: auto;
}

#drawerHolder3_Series {
    position: absolute;

    top:0%;

    width: 100%;
    height: 100%;

    z-index: 5;

    clip-path: polygon(0% 0%, 100% 0%, 99% 50%, 86.55% 100.05%, 0% 100.05%);

    /* background-color: rgba(0, 0, 150, 0.5); */
}

#drawerContainer3_Series {
    position: absolute;

    height: 100%;
    width: 100%;

    left: -23%;
    bottom: -90.8%;
    
    z-index: 5;

    pointer-events: all;
}

.drawer_open_series3 {
    animation: drawer_popup_series3 0.2s ease-in-out forwards;
}

.drawer_close_series3 {
    animation: drawer_collapse_series3 0.2s ease-in-out forwards;
}

@keyframes drawer_popup_series3 {
    from {
        bottom: -90.8%;
        left: -23%;
    }
    to {
        bottom: -66%;
        left: -18%;
    }
}

@keyframes drawer_collapse_series3 {
    from {
        bottom: -66%;
        left: -18%;
    }
    to {
        bottom: -90.8%;
        left: -23%;
    }
}

#drawer3_Series {
    height: 37%;
    width: auto;
}

#optionsContainer3_series {
    position: absolute;

    width: 100%;
    height: 100%;

    left: 37%;
    top: 0%;

    container-type: size;
}

#optionsContainer3_series h2 {
    position: absolute;

    /* width: 100%; */

    left: 58.2%;
    left: 60%;
    transform: translate(-50%);
    top: 1.9%;

    margin: 0px;

    z-index: 5;
    font: 4.9cqh Diesel;

    text-wrap: nowrap;
    text-transform: uppercase;
}

#optionsContainer3_series h3 {
    position: absolute;

    left: 57.9%; 
    transform: translate(-50%);
    top: 0.5%;

    z-index: 5;
    font: 2.05cqh MyriadPro-Regular;
    text-transform: uppercase;
    letter-spacing: 0.2cqh;
}

/* new stuff */
#drawerHolder4_Series {
    position: absolute;

    top:0%;

    width: 100%;
    height: 100%;

    z-index: 6;

    clip-path: polygon(0% 0%, 100% 0%, 100% 50%, 100% 100.05%, 0% 100.05%);

    /* background-color: rgba(0, 0, 150, 0.5); */
}

#drawerContainer4_Series {
    position: absolute;

    height: 100%;
    width: 100%;

    left: -22%;
    bottom: -90.8%;
    
    z-index: 5;

    pointer-events: all;
}

.drawer_open_series4 {
    animation: drawer_popup_series4 0.2s ease-in-out forwards;
}

.drawer_close_series4 {
    animation: drawer_collapse_series4 0.2s ease-in-out forwards;
}

@keyframes drawer_popup_series4 {
    from {
        bottom: -90.8%;
        left: -22%;
    }
    to {
        bottom: -66%;
        left: -18%;
    }
}

@keyframes drawer_collapse_series4 {
    from {
        bottom: -66%;
        left: -18%;
    }
    to {
        bottom: -90.8%;
        left: -22%;
    }
}

#drawer4_Series {
    height: 37%;
    width: auto;
}

#optionsContainer4_series {
    position: absolute;

    width: 100%;
    height: 100%;

    left: 41%;
    top: 0%;

    container-type: size;
}

#optionsContainer4_series h2 {
    position: absolute;

    /* width: 100%; */

    left: 58.2%;
    transform: translate(-50%);
    top: 1.9%;

    margin: 0px;

    z-index: 6;
    font: 4.9cqh Diesel;

    text-wrap: nowrap;
    text-transform: uppercase;
}

#optionsContainer4_series h3 {
    position: absolute;

    left: 57.9%; 
    transform: translate(-50%);
    top: 0.5%;

    z-index: 6;
    font: 2.05cqh MyriadPro-Regular;
    text-transform: uppercase;
    letter-spacing: 0.2cqh;
}
/* end new stuff */

#optionsContainer1_series ul {
    position: absolute;
    list-style: none;

    left: 25%;
    top: 11.5%;

    width: 70%;

    font: 1.8cqh MyriadPro-Regular;
}

#optionsContainer2_series ul {
    position: absolute;
    list-style: none;

    left: 30%;
    top: 11.5%;

    width: 60%;

    font: 1.8cqh MyriadPro-Regular;}

#optionsContainer3_series ul {
    position: absolute;
    list-style: none;

    left: 27%;
    top: 11.5%;

    width: 68%;

    font: 1.8cqh MyriadPro-Regular;
}

#optionsContainer4_series ul {
    position: absolute;
    list-style: none;

    left: 27%;
    top: 11.5%;

    width: 70%;

    font: 1.8cqh MyriadPro-Regular;
}

li {
    padding-left: 0em;
}

#inputDiv1 ul li:before {
    content: "- ";
}

#inputDiv2 ul li:before {
    content: "- ";
}

#inputDiv3 ul li:before {
    content: "- ";
}

#inputDiv4 ul li:before {
    content: "- ";
}

#input1-SeriesSelection {
    clip-path: polygon(0% 0%, 83.8% 0%, 98.9% 50%, 83.8% 100%, 0% 100%);
}

#input2-SeriesSelection {
    clip-path: polygon(1.5% 0%, 86.3% 0%, 98.8% 50%, 86.3% 100%, 1.5% 100%, 14% 50%);
}

#input3-SeriesSelection {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 12.9% 50%);
}

#input4-SeriesSelection {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 12.9% 50%);
}

.input-SeriesSelection {
    position: relative;
    height: 100%;
    width: 100%;
    opacity: 0;
    z-index: 2;

    pointer-events: all;
}

.inputImage {
    position: absolute;

    /* left: 0; */
    right: 0;

    width: 100%;
    height: 100%;

    transform: scale(100%);

    opacity: 1;
    z-index: 4;

    pointer-events: none;

    transition: opacity 0.2s 0.3s ease-in-out;
}

.inputImage-Highlight {
    position: absolute;

    left: 0%;

    width: 100%;
    height: 100%;

    opacity: 0;
    -moz-opacity: 0;
    filter: alpha(opacity=0);
    z-index: 5;

    transition: opacity 0.2s 0.3s ease-in-out;
}

#base-car {
    position: absolute;

    left: 47%;
    top: 47%;
    transform: translate(-50%, -50%) rotate(1.2deg);

    height: 80%;

    z-index: 5;
}

#carbon-car {
    position: absolute;

    left: 55%;
    top: 47%;
    transform: translate(-50%, -50%) rotate(0.1deg);

    height: 80%;

    z-index: 5;
}

#liquid-carbon-car {
    position: absolute;

    left: 55%;
    top: 47%;
    transform: translate(-50%, -50%) rotate(0.3deg);

    height: 80%;

    z-index: 5;
}

#special-edition-car {
    position: absolute;

    left: 55%;
    top: 47%;
    transform: translate(-50%, -50%) rotate(0.3deg);

    height: 80%;

    z-index: 5;
}

.car {
    background-color: transparent;
}

.car-hover {
    animation: car-embiggen 1s forwards;
}

.car-endhover {
    animation: car-emsmollen 0.4s forwards;
}

.details_header {
    position: absolute;
    
    left: 58%;
    top: 7.7%;

    transform: translate(-50%);

    text-transform: uppercase;

    font: 1.2cqh MyriadPro-Regular;
    letter-spacing: 0.05cqh;

    color: white
}

@keyframes car-embiggen {
    from {
        height: 77%;
    }
    to {
        height: 84%;
    }
}

@keyframes car-emsmollen {
    from {
        height: 84%;
    }
    to {
        height: 77%;
    }
}

.black-background {
    background-color: black;
}

.fadingOutImage1 {
    animation-duration: 0.3s;
    animation-name: fade-out1;
    animation-fill-mode: forwards;
}

.fadingOutImage2 {
    animation-duration: 0.6s;
    animation-name: fade-out2;
    animation-fill-mode: forwards;
}

.fadingOutImage3 {
    animation-duration: 0.9s;
    animation-name: fade-out3;
    animation-fill-mode: forwards;
}

.fadingOutImage4 {
    animation-duration: 1.2s;
    animation-name: fade-out4;
    animation-fill-mode: forwards;
}

@keyframes fade-in {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes remove-blocker {

    0%,
    99.99% {
        pointer-events: all;
    }

    100% {
        pointer-events: none;
    }
}

@keyframes fade-out1 {

    from {
        opacity: 1
    }

    100% {
        opacity: 0.001
    }
}

@keyframes fade-out2 {

    from,
    50% {
        opacity: 1
    }

    100% {
        opacity: 0
    }
}

@keyframes fade-out3 {

    from,
    66.666% {
        opacity: 1
    }

    100% {
        opacity: 0
    }
}

@keyframes fade-out4 {

    from,
    75% {
        opacity: 1
    }

    100% {
        opacity: 0
    }
}`, "",{"version":3,"sources":["webpack://./src/components/SeriesSelection_4Options_VerticalStack.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;;IAEb,uBAAuB;IACvB,mBAAmB;;IAEnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;;IAEb,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;;IAEf;;;KAGC;;IAED,mBAAmB;;IAEnB,UAAU;;IAEV,6BAA6B;;IAE7B,mBAAmB;;IAEnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;;IAElB,eAAe;;IAEf,mBAAmB;;IAEnB,UAAU;;IAEV,6BAA6B;IAC7B,qBAAqB;;IAErB,mBAAmB;;IAEnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;;IAElB,eAAe;;IAEf,mBAAmB;;IAEnB,UAAU;;IAEV,6BAA6B;IAC7B,qBAAqB;;IAErB,mBAAmB;;IAEnB,eAAe;;IAEf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;;IAElB,eAAe;;IAEf,UAAU;;IAEV,6BAA6B;IAC7B,qBAAqB;;IAErB,mBAAmB;;IAEnB,eAAe;;IAEf,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;;IAElB,WAAW;IACX,UAAU;;IAEV,WAAW;;IAEX,oBAAoB;;IAEpB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,UAAU;;IAEV,WAAW;;IAEX,oBAAoB;;IAEpB,oBAAoB;IACpB,iBAAiB;;IAEjB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,UAAU;;IAEV,WAAW;;IAEX,oBAAoB;;IAEpB,oBAAoB;IACpB,iBAAiB;;IAEjB,6BAA6B;AACjC;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,sDAAsD;AAC1D;;;AAGA;IACI,sDAAsD;AAC1D;;AAEA,aAAa;AACb;IACI,sDAAsD;AAC1D;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;;IAEX,UAAU;IACV,UAAU;;IAEV,6BAA6B;AACjC;;AAEA,SAAS;;AAET,MAAM;;AAEN,kBAAkB;AAClB;IACI,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,UAAU;;IAEV,UAAU;IACV,+BAA+B;IAC/B,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,QAAQ;IACR,UAAU;;IAEV,WAAW;;IAEX,UAAU;IACV,oBAAoB;IACpB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;;IAElB,QAAQ;IACR,QAAQ;;IAER,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,QAAQ;;IAER,UAAU;IACV,WAAW;;IAEX,8BAA8B;IAC9B,cAAc;;IAEd,UAAU;;IAEV,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;;IAEjB,2BAA2B;;IAE3B,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;;IAEnB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,WAAW;AACf;;AAEA,QAAQ;;AAER;IACI,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,UAAU;;IAEV,UAAU;IACV,+BAA+B;IAC/B,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,QAAQ;IACR,UAAU;;IAEV,WAAW;;IAEX,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;;IAEpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;;IAElB,OAAO;IACP,QAAQ;;IAER,WAAW;AACf;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,QAAQ;;IAER,UAAU;IACV,WAAW;;IAEX,8BAA8B;IAC9B,cAAc;;IAEd,UAAU;;IAEV,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;;IAEjB,2BAA2B;;IAE3B,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;;IAEnB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,WAAW;AACf;;AAEA,MAAM;;AAEN;IACI,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,UAAU;;IAEV,UAAU;IACV,+BAA+B;IAC/B,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,QAAQ;IACR,UAAU;;IAEV,WAAW;;IAEX,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;;IAEpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;;IAElB,OAAO;IACP,QAAQ;;IAER,WAAW;AACf;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,QAAQ;;IAER,UAAU;IACV,WAAW;;IAEX,8BAA8B;IAC9B,cAAc;;IAEd,UAAU;;IAEV,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;;IAEjB,2BAA2B;;IAE3B,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;;IAEnB,mBAAmB;AACvB;;;;AAIA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,WAAW;AACf;;AAEA;IACI,UAAU;;IAEV,wBAAwB;IACxB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,UAAU;;IAEV,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA,SAAS;;AAET;IACI,kBAAkB;;IAElB,MAAM;;IAEN,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,2EAA2E;;IAE3E,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;;IAElB,YAAY;IACZ,WAAW;;IAEX,UAAU;IACV,cAAc;;IAEd,UAAU;;IAEV,mBAAmB;AACvB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI;QACI,cAAc;QACd,UAAU;IACd;IACA;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,cAAc;QACd,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;;IAElB,YAAY;IACZ,WAAW;IACX,OAAO;IACP,UAAU;IACV,oBAAoB;;IAEpB,gCAAgC;AACpC;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;;IAElB,QAAQ;;IAER,WAAW;IACX,WAAW;;IAEX,UAAU;IACV,eAAe;IACf,wBAAwB;IACxB,UAAU;;IAEV,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,WAAW;IACX,OAAO;;IAEP,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,0BAA0B;IAC1B,SAAS;;IAET,WAAW;;IAEX,UAAU;IACV,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;IAElB,YAAY;IACZ,WAAW;IACX,OAAO;IACP,UAAU;IACV,oBAAoB;;IAEpB,gCAAgC;AACpC;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,0BAA0B;IAC1B,SAAS;;IAET,UAAU;IACV,+BAA+B;IAC/B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;;IAElB,YAAY;IACZ,WAAW;IACX,OAAO;IACP,UAAU;IACV,oBAAoB;;IAEpB,gCAAgC;AACpC;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,kBAAkB;;IAElB,YAAY;IACZ,WAAW;IACX,OAAO;IACP,UAAU;IACV,oBAAoB;;IAEpB,gCAAgC;AACpC;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,kBAAkB;;IAElB,MAAM;;IAEN,WAAW;IACX,YAAY;;IAEZ,UAAU;;IAEV,2EAA2E;;IAE3E,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;;IAElB,YAAY;IACZ,WAAW;;IAEX,YAAY;IACZ,cAAc;;IAEd,UAAU;;IAEV,mBAAmB;AACvB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI;QACI,cAAc;QACd,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,cAAc;QACd,YAAY;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;;IAElB,MAAM;;IAEN,WAAW;IACX,YAAY;;IAEZ,UAAU;;IAEV,uEAAuE;;IAEvE,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;;IAElB,YAAY;IACZ,WAAW;;IAEX,UAAU;IACV,cAAc;;IAEd,UAAU;;IAEV,mBAAmB;AACvB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI;QACI,cAAc;QACd,UAAU;IACd;IACA;QACI,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,UAAU;IACd;IACA;QACI,cAAc;QACd,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,SAAS;IACT,OAAO;;IAEP,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;;IAElB,iBAAiB;;IAEjB,WAAW;IACX,SAAS;IACT,0BAA0B;IAC1B,SAAS;;IAET,WAAW;;IAEX,UAAU;IACV,mBAAmB;;IAEnB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,0BAA0B;IAC1B,SAAS;;IAET,UAAU;IACV,+BAA+B;IAC/B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,cAAc;AACd;IACI,kBAAkB;;IAElB,MAAM;;IAEN,WAAW;IACX,YAAY;;IAEZ,UAAU;;IAEV,sEAAsE;;IAEtE,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;;IAElB,YAAY;IACZ,WAAW;;IAEX,UAAU;IACV,cAAc;;IAEd,UAAU;;IAEV,mBAAmB;AACvB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI;QACI,cAAc;QACd,UAAU;IACd;IACA;QACI,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,UAAU;IACd;IACA;QACI,cAAc;QACd,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,SAAS;IACT,OAAO;;IAEP,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;;IAElB,iBAAiB;;IAEjB,WAAW;IACX,0BAA0B;IAC1B,SAAS;;IAET,WAAW;;IAEX,UAAU;IACV,mBAAmB;;IAEnB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,0BAA0B;IAC1B,SAAS;;IAET,UAAU;IACV,+BAA+B;IAC/B,yBAAyB;IACzB,sBAAsB;AAC1B;AACA,kBAAkB;;AAElB;IACI,kBAAkB;IAClB,gBAAgB;;IAEhB,SAAS;IACT,UAAU;;IAEV,UAAU;;IAEV,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;;IAEhB,SAAS;IACT,UAAU;;IAEV,UAAU;;IAEV,8BAA8B,CAAC;;AAEnC;IACI,kBAAkB;IAClB,gBAAgB;;IAEhB,SAAS;IACT,UAAU;;IAEV,UAAU;;IAEV,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;;IAEhB,SAAS;IACT,UAAU;;IAEV,UAAU;;IAEV,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mEAAmE;AACvE;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,iEAAiE;AACrE;;AAEA;IACI,iEAAiE;AACrE;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,UAAU;;IAEV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;;IAElB,aAAa;IACb,QAAQ;;IAER,WAAW;IACX,YAAY;;IAEZ,sBAAsB;;IAEtB,UAAU;IACV,UAAU;;IAEV,oBAAoB;;IAEpB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;;IAElB,QAAQ;;IAER,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,eAAe;IACf,wBAAwB;IACxB,UAAU;;IAEV,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,QAAQ;IACR,+CAA+C;;IAE/C,WAAW;;IAEX,UAAU;AACd;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,QAAQ;IACR,+CAA+C;;IAE/C,WAAW;;IAEX,UAAU;AACd;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,QAAQ;IACR,+CAA+C;;IAE/C,WAAW;;IAEX,UAAU;AACd;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,QAAQ;IACR,+CAA+C;;IAE/C,WAAW;;IAEX,UAAU;AACd;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,SAAS;;IAET,0BAA0B;;IAE1B,yBAAyB;;IAEzB,8BAA8B;IAC9B,uBAAuB;;IAEvB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;;IAEI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ","sourcesContent":["#seriesRoot {\r\n    position: relative;\r\n    display: flex;\r\n\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n#seriesParent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    aspect-ratio: 16/9;\r\n    width: 100%;\r\n    max-width: 177.778vh;\r\n    max-height: 56.25vw;\r\n    height: auto;\r\n}\r\n\r\n#interactionBlocker-SeriesSelection {\r\n    position: absolute;\r\n    width: 100vw;\r\n    height: 100vh;\r\n\r\n    z-index: 99;\r\n}\r\n\r\n.interactionBlockStart-SeriesSelection {\r\n    animation-duration: 1.2s;\r\n    animation-name: remove-blocker;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n.interactionBlockEnd-SeriesSelection {\r\n    pointer-events: all;\r\n}\r\n\r\n#inputDiv1 {\r\n    position: relative;\r\n    height: 24.375%;\r\n    \r\n    /* Previous settings for thick black outline\r\n    width: 98%;\r\n    left: 1%;\r\n    */\r\n\r\n    margin-bottom: 0.5%;\r\n\r\n    z-index: 3;\r\n\r\n    animation-fill-mode: forwards;\r\n\r\n    pointer-events: all;\r\n\r\n    object-fit: contain;\r\n    overflow: hidden;\r\n}\r\n\r\n#inputDiv2 {\r\n    position: relative;\r\n\r\n    height: 24.375%;\r\n\r\n    margin-bottom: 0.5%;\r\n\r\n    z-index: 2;\r\n\r\n    animation-fill-mode: forwards;\r\n    animation-delay: 0.4s;\r\n\r\n    pointer-events: all;\r\n\r\n    overflow: hidden;\r\n}\r\n\r\n#inputDiv3 {\r\n    position: relative;\r\n\r\n    height: 24.375%;\r\n\r\n    margin-bottom: 0.5%;\r\n\r\n    z-index: 1;\r\n\r\n    animation-fill-mode: forwards;\r\n    animation-delay: 0.8s;\r\n\r\n    pointer-events: all;\r\n\r\n    margin-left: 0%;\r\n\r\n    overflow: hidden;\r\n}\r\n\r\n#inputDiv4 {\r\n    position: relative;\r\n\r\n    height: 24.375%;\r\n\r\n    z-index: 0;\r\n\r\n    animation-fill-mode: forwards;\r\n    animation-delay: 1.2s;\r\n\r\n    pointer-events: all;\r\n\r\n    margin-left: 0%;\r\n\r\n    overflow: hidden;\r\n}\r\n\r\n/* detail divs */\r\n#detailsDiv1 {\r\n    position: absolute;\r\n\r\n    height:100%;\r\n    width: 45%;\r\n\r\n    z-index: 10;\r\n\r\n    container-type: size;\r\n\r\n    pointer-events: none;\r\n    user-select: none;\r\n}\r\n\r\n#detailsDiv2 {\r\n    position: absolute;\r\n\r\n    height:100%;\r\n    width: 45%;\r\n\r\n    z-index: 10;\r\n\r\n    container-type: size;\r\n\r\n    pointer-events: none;\r\n    user-select: none;\r\n\r\n    /* justify-content: center; */\r\n}\r\n\r\n#detailsDiv4 {\r\n    position: absolute;\r\n\r\n    height:100%;\r\n    width: 45%;\r\n\r\n    z-index: 10;\r\n\r\n    container-type: size;\r\n\r\n    pointer-events: none;\r\n    user-select: none;\r\n\r\n    /* justify-content: center; */\r\n}\r\n\r\n#inputDiv1:hover > img {\r\n    animation: initCarPunchout 0.5s normal 0.0s 1 forwards;\r\n}\r\n\r\n#inputDiv2:hover > img {\r\n    animation: initCarPunchout 0.5s normal 0.0s 1 forwards;\r\n}\r\n\r\n#inputDiv3:hover > img {\r\n    animation: initCarPunchout 0.5s normal 0.0s 1 forwards;\r\n}\r\n\r\n#inputDiv4:hover > img {\r\n    animation: initCarPunchout 0.5s normal 0.0s 1 forwards;\r\n}\r\n\r\n\r\n.inputImage:not(:hover) {\r\n    animation: exitCarPunchout 0.5s normal 0.0s 1 forwards;\r\n}\r\n\r\n/* Outlines */\r\n.inputImage:not(:hover) {\r\n    animation: exitCarPunchout 0.5s normal 0.0s 1 forwards;\r\n}\r\n\r\n#inputDiv1:hover > .outlineDiv {\r\n    animation: fade-in 0.5s normal 0.0s 1 forwards;\r\n}\r\n\r\n#inputDiv2:hover > .outlineDiv {\r\n    animation: fade-in 0.5s normal 0.0s 1 forwards;\r\n}\r\n\r\n#inputDiv3:hover > .outlineDiv {\r\n    animation: fade-in 0.5s normal 0.0s 1 forwards;\r\n}\r\n\r\n#inputDiv4:hover > .outlineDiv {\r\n    animation: fade-in 0.5s normal 0.0s 1 forwards;\r\n}\r\n\r\n.inputImage:not(:hover) ~ .outlineDiv {\r\n    animation: fade-out1 0.3s normal 0.0s 1 forwards;\r\n}\r\n\r\n@keyframes initCarPunchout {\r\n    from {\r\n        transform: scale(100%);\r\n    }\r\n\r\n    to {\r\n        transform: scale(110%);\r\n    }\r\n}\r\n\r\n@keyframes exitCarPunchout {\r\n    from {\r\n        transform: scale(110%);\r\n    }\r\n\r\n    to {\r\n        transform: scale(100%);\r\n    }\r\n}\r\n\r\n.outlineDiv {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n\r\n    z-index: 4;\r\n    opacity: 0;\r\n\r\n    border: 0.25cqw solid #ed9032;\r\n}\r\n\r\n/* text */\r\n\r\n/* 1 */\r\n\r\n/* \"Series\" text */\r\n#detailsDiv1 h3 {\r\n    position: absolute;\r\n\r\n    left: 50%; \r\n    transform: translate(-50%);\r\n    top: 23.5%;\r\n\r\n    z-index: 5;\r\n    font: 9.05cqh MyriadPro-Regular;\r\n    font-weight: bold;\r\n    color: rgb(97, 97, 97);\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5cqh;\r\n}\r\n\r\n#detailsDiv1 h2 {\r\n    position: absolute;\r\n\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n    top: 31%;\r\n    width: 65%;\r\n\r\n    margin: 0px;\r\n\r\n    z-index: 5;\r\n    font: 23.5cqh Diesel;\r\n    text-transform: uppercase;\r\n    letter-spacing: 2cqh;\r\n}\r\n\r\n#detailsDiv1 div {\r\n    position: relative;\r\n\r\n    left: 0%;\r\n    top: 60%;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n#detailsDiv1 button {\r\n    position: absolute;\r\n\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n    top: 80%;\r\n\r\n    width: 18%;\r\n    height: 12%;\r\n\r\n    background-color: rgb(0, 0, 0);\r\n    color: #e0e0df;\r\n\r\n    z-index: 5;\r\n\r\n    font: 5cqh MyriadPro-Bold;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.2cqh;\r\n    font-weight: normal;\r\n    line-height: 190%;\r\n\r\n    padding: 0px, 0px, 0px, 0px;\r\n\r\n    box-shadow: none;\r\n    border-style: solid;\r\n    border-radius: 25cqh;\r\n    border-color: black;\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n#detailsDiv1 button:hover {\r\n    /* transparent background */\r\n    background-color: rgb(255, 255, 255, 0);\r\n    color:black;\r\n}\r\n\r\n/*2 + 3*/\r\n\r\n#detailsDiv2 h3 {\r\n    position: absolute;\r\n\r\n    left: 50%; \r\n    transform: translate(-50%);\r\n    top: 10.5%;\r\n\r\n    z-index: 5;\r\n    font: 9.05cqh MyriadPro-Regular;\r\n    font-weight: bold;\r\n    color: rgb(97, 97, 97);\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5cqh;\r\n}\r\n\r\n#detailsDiv2 h2 {\r\n    position: absolute;\r\n\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n    top: 16%;\r\n    width: 90%;\r\n\r\n    margin: 0px;\r\n\r\n    z-index: 5;\r\n    font: 30cqh Diesel;\r\n    text-transform: uppercase;\r\n    letter-spacing: 2cqh;\r\n\r\n    text-align: center;\r\n}\r\n\r\n#detailsDiv2 div {\r\n    position: relative;\r\n\r\n    left: 0;\r\n    top: 50%;\r\n\r\n    width: 100%;\r\n}\r\n\r\n#detailsDiv2 button {\r\n    position: absolute;\r\n\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n    top: 80%;\r\n\r\n    width: 18%;\r\n    height: 12%;\r\n\r\n    background-color: rgb(0, 0, 0);\r\n    color: #e0e0df;\r\n\r\n    z-index: 5;\r\n\r\n    font: 5cqh MyriadPro-Bold;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.2cqh;\r\n    font-weight: normal;\r\n    line-height: 190%;\r\n\r\n    padding: 0px, 0px, 0px, 0px;\r\n\r\n    box-shadow: none;\r\n    border-style: solid;\r\n    border-radius: 25cqh;\r\n    border-color: black;\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n#detailsDiv2 button:hover {\r\n    /* transparent background */\r\n    background-color: rgb(255, 255, 255, 0);\r\n    color:black;\r\n}\r\n\r\n/* 4 */\r\n\r\n#detailsDiv4 h3 {\r\n    position: absolute;\r\n\r\n    left: 50%; \r\n    transform: translate(-50%);\r\n    top: 10.5%;\r\n\r\n    z-index: 5;\r\n    font: 9.05cqh MyriadPro-Regular;\r\n    font-weight: bold;\r\n    color: rgb(97, 97, 97);\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5cqh;\r\n}\r\n\r\n#detailsDiv4 h2 {\r\n    position: absolute;\r\n\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n    top: 16%;\r\n    width: 90%;\r\n\r\n    margin: 0px;\r\n\r\n    z-index: 5;\r\n    font: 30cqh Diesel;\r\n    text-transform: uppercase;\r\n    letter-spacing: 2cqh;\r\n\r\n    text-align: center;\r\n}\r\n\r\n#detailsDiv4 div {\r\n    position: relative;\r\n\r\n    left: 0;\r\n    top: 50%;\r\n\r\n    width: 100%;\r\n}\r\n\r\n#detailsDiv4 button {\r\n    position: absolute;\r\n\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n    top: 74%;\r\n\r\n    width: 18%;\r\n    height: 12%;\r\n\r\n    background-color: rgb(0, 0, 0);\r\n    color: #e0e0df;\r\n\r\n    z-index: 5;\r\n\r\n    font: 5cqh MyriadPro-Bold;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.2cqh;\r\n    font-weight: normal;\r\n    line-height: 190%;\r\n\r\n    padding: 0px, 0px, 0px, 0px;\r\n\r\n    box-shadow: none;\r\n    border-style: solid;\r\n    border-radius: 25cqh;\r\n    border-color: black;\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n\r\n\r\n#detailsDiv4 button:hover {\r\n    /* transparent background */\r\n    background-color: rgb(255, 255, 255, 0);\r\n    color:black;\r\n}\r\n\r\n.inputDiv-SeriesSelection-Intro {\r\n    opacity: 0;\r\n\r\n    animation-duration: 0.3s;\r\n    animation-name: fade-in;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n.inputDiv-SeriesSelection-Outro {\r\n    opacity: 1;\r\n\r\n    animation-duration: 0.3s;\r\n    animation-name: fade-out1;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n/* ---- */\r\n\r\n#drawerHolder1_Series {\r\n    position: absolute;\r\n\r\n    top:0%;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    z-index: 5;\r\n    clip-path: polygon(0% 0%, 83.8% 0%, 98.8% 50.6%, 84.6% 100.05%, 0% 100.05%);\r\n\r\n    /* background-color: rgba(150, 0, 0, 0.5); */\r\n}\r\n\r\n#drawerContainer1_Series {\r\n    display: relative;\r\n    position: absolute;\r\n\r\n    height: 100%;\r\n    width: 100%;\r\n\r\n    left: -26%;\r\n    bottom: -90.8%;\r\n\r\n    z-index: 5;\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n.drawer_open_series1 {\r\n    animation: drawer_popup_series1 0.2s ease-in-out forwards;\r\n}\r\n\r\n.drawer_close_series1 {\r\n    animation: drawer_collapse_series1 0.2s ease-in-out forwards;\r\n}\r\n\r\n@keyframes drawer_popup_series1 {\r\n    from {\r\n        bottom: -90.8%;\r\n        left: -26%;\r\n    }\r\n    to {\r\n        bottom: -66%;\r\n        left: -22.5%;\r\n    }\r\n}\r\n\r\n@keyframes drawer_collapse_series1 {\r\n    from {\r\n        bottom: -66%;\r\n        left: -22.5%;\r\n    }\r\n    to {\r\n        bottom: -90.8%;\r\n        left: -26%;;\r\n    }\r\n}\r\n\r\n#drawerHover1_Series {\r\n    position: absolute;\r\n\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0%;\r\n    left: -42%;\r\n    pointer-events: none;\r\n\r\n    transition: top 0.2s ease-in-out;\r\n}\r\n\r\n#drawerHover1_Series:hover {\r\n    top: -1%;\r\n}\r\n\r\n#drawer1_Series {\r\n    width: auto;\r\n    height: 37%;\r\n}\r\n\r\n.drawer_highlight_Series {\r\n    position: absolute;\r\n\r\n    left: 0%;\r\n\r\n    width: auto;\r\n    height: 30%;\r\n\r\n    opacity: 0;\r\n    -moz-opacity: 0;\r\n    filter: alpha(opacity=0);\r\n    z-index: 5;\r\n\r\n    transition: opacity 0.5s 0.1s ease-in-out;\r\n}\r\n\r\n#optionsContainer2_series {\r\n    position: absolute;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    left: 37.2%;\r\n    top: 0%;\r\n\r\n    container-type: size;\r\n}\r\n\r\n#optionsContainer2_series h2 {\r\n    position: absolute;\r\n\r\n    left: 58.2%;\r\n    transform: translate(-50%);\r\n    top: 1.9%;\r\n\r\n    margin: 0px;\r\n\r\n    z-index: 5;\r\n    font: 4.9cqh Diesel;\r\n    text-transform: uppercase;\r\n}\r\n\r\n#drawerHover2_Series {\r\n    position: absolute;\r\n\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0%;\r\n    left: -29%;\r\n    pointer-events: none;\r\n\r\n    transition: top 0.2s ease-in-out;\r\n}\r\n\r\n#drawerHover2_Series:hover {\r\n    top: -1%;\r\n}\r\n\r\n#optionsContainer2_series h3 {\r\n    position: absolute;\r\n\r\n    left: 57.9%; \r\n    transform: translate(-50%);\r\n    top: 0.5%;\r\n\r\n    z-index: 5;\r\n    font: 2.05cqh MyriadPro-Regular;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.2cqh;\r\n}\r\n\r\n#drawerHover3_Series {\r\n    position: absolute;\r\n\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0%;\r\n    left: -26%;\r\n    pointer-events: none;\r\n\r\n    transition: top 0.2s ease-in-out;\r\n}\r\n\r\n#drawerHover3_Series:hover {\r\n    top: -1%;\r\n}\r\n\r\n#drawerHover4_Series {\r\n    position: absolute;\r\n\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0%;\r\n    left: -26%;\r\n    pointer-events: none;\r\n\r\n    transition: top 0.2s ease-in-out;\r\n}\r\n\r\n#drawerHover4_Series:hover {\r\n    top: -1%;\r\n}\r\n\r\n#drawerHolder2_Series {\r\n    position: absolute;\r\n\r\n    top:0%;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    z-index: 5;\r\n\r\n    clip-path: polygon(0% 0%, 86.45% 0%, 98.8% 51%, 86.57% 100.05%, 0% 100.05%);\r\n\r\n    /* background-color: rgba(0, 0, 150, 0.5); */\r\n}\r\n\r\n#drawerContainer2_Series {\r\n    position: absolute;\r\n\r\n    height: 100%;\r\n    width: 100%;\r\n\r\n    left: -18.5%;\r\n    bottom: -90.8%;\r\n    \r\n    z-index: 5;\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n.drawer_open_series2 {\r\n    animation: drawer_popup_series2 0.2s ease-in-out forwards;\r\n}\r\n\r\n.drawer_close_series2 {\r\n    animation: drawer_collapse_series2 0.2s ease-in-out forwards;\r\n}\r\n\r\n@keyframes drawer_popup_series2 {\r\n    from {\r\n        bottom: -90.8%;\r\n        left: -18.5%;\r\n    }\r\n    to {\r\n        bottom: -66%;\r\n        left: -13.5%;\r\n    }\r\n}\r\n\r\n@keyframes drawer_collapse_series2 {\r\n    from {\r\n        bottom: -66%;\r\n        left: -13.5%;\r\n    }\r\n    to {\r\n        bottom: -90.8%;\r\n        left: -18.5%;\r\n    }\r\n}\r\n\r\n#drawer2_Series {\r\n    height:37%;\r\n    width: auto;\r\n}\r\n\r\n#drawerHolder3_Series {\r\n    position: absolute;\r\n\r\n    top:0%;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    z-index: 5;\r\n\r\n    clip-path: polygon(0% 0%, 100% 0%, 99% 50%, 86.55% 100.05%, 0% 100.05%);\r\n\r\n    /* background-color: rgba(0, 0, 150, 0.5); */\r\n}\r\n\r\n#drawerContainer3_Series {\r\n    position: absolute;\r\n\r\n    height: 100%;\r\n    width: 100%;\r\n\r\n    left: -23%;\r\n    bottom: -90.8%;\r\n    \r\n    z-index: 5;\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n.drawer_open_series3 {\r\n    animation: drawer_popup_series3 0.2s ease-in-out forwards;\r\n}\r\n\r\n.drawer_close_series3 {\r\n    animation: drawer_collapse_series3 0.2s ease-in-out forwards;\r\n}\r\n\r\n@keyframes drawer_popup_series3 {\r\n    from {\r\n        bottom: -90.8%;\r\n        left: -23%;\r\n    }\r\n    to {\r\n        bottom: -66%;\r\n        left: -18%;\r\n    }\r\n}\r\n\r\n@keyframes drawer_collapse_series3 {\r\n    from {\r\n        bottom: -66%;\r\n        left: -18%;\r\n    }\r\n    to {\r\n        bottom: -90.8%;\r\n        left: -23%;\r\n    }\r\n}\r\n\r\n#drawer3_Series {\r\n    height: 37%;\r\n    width: auto;\r\n}\r\n\r\n#optionsContainer3_series {\r\n    position: absolute;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    left: 37%;\r\n    top: 0%;\r\n\r\n    container-type: size;\r\n}\r\n\r\n#optionsContainer3_series h2 {\r\n    position: absolute;\r\n\r\n    /* width: 100%; */\r\n\r\n    left: 58.2%;\r\n    left: 60%;\r\n    transform: translate(-50%);\r\n    top: 1.9%;\r\n\r\n    margin: 0px;\r\n\r\n    z-index: 5;\r\n    font: 4.9cqh Diesel;\r\n\r\n    text-wrap: nowrap;\r\n    text-transform: uppercase;\r\n}\r\n\r\n#optionsContainer3_series h3 {\r\n    position: absolute;\r\n\r\n    left: 57.9%; \r\n    transform: translate(-50%);\r\n    top: 0.5%;\r\n\r\n    z-index: 5;\r\n    font: 2.05cqh MyriadPro-Regular;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.2cqh;\r\n}\r\n\r\n/* new stuff */\r\n#drawerHolder4_Series {\r\n    position: absolute;\r\n\r\n    top:0%;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    z-index: 6;\r\n\r\n    clip-path: polygon(0% 0%, 100% 0%, 100% 50%, 100% 100.05%, 0% 100.05%);\r\n\r\n    /* background-color: rgba(0, 0, 150, 0.5); */\r\n}\r\n\r\n#drawerContainer4_Series {\r\n    position: absolute;\r\n\r\n    height: 100%;\r\n    width: 100%;\r\n\r\n    left: -22%;\r\n    bottom: -90.8%;\r\n    \r\n    z-index: 5;\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n.drawer_open_series4 {\r\n    animation: drawer_popup_series4 0.2s ease-in-out forwards;\r\n}\r\n\r\n.drawer_close_series4 {\r\n    animation: drawer_collapse_series4 0.2s ease-in-out forwards;\r\n}\r\n\r\n@keyframes drawer_popup_series4 {\r\n    from {\r\n        bottom: -90.8%;\r\n        left: -22%;\r\n    }\r\n    to {\r\n        bottom: -66%;\r\n        left: -18%;\r\n    }\r\n}\r\n\r\n@keyframes drawer_collapse_series4 {\r\n    from {\r\n        bottom: -66%;\r\n        left: -18%;\r\n    }\r\n    to {\r\n        bottom: -90.8%;\r\n        left: -22%;\r\n    }\r\n}\r\n\r\n#drawer4_Series {\r\n    height: 37%;\r\n    width: auto;\r\n}\r\n\r\n#optionsContainer4_series {\r\n    position: absolute;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    left: 41%;\r\n    top: 0%;\r\n\r\n    container-type: size;\r\n}\r\n\r\n#optionsContainer4_series h2 {\r\n    position: absolute;\r\n\r\n    /* width: 100%; */\r\n\r\n    left: 58.2%;\r\n    transform: translate(-50%);\r\n    top: 1.9%;\r\n\r\n    margin: 0px;\r\n\r\n    z-index: 6;\r\n    font: 4.9cqh Diesel;\r\n\r\n    text-wrap: nowrap;\r\n    text-transform: uppercase;\r\n}\r\n\r\n#optionsContainer4_series h3 {\r\n    position: absolute;\r\n\r\n    left: 57.9%; \r\n    transform: translate(-50%);\r\n    top: 0.5%;\r\n\r\n    z-index: 6;\r\n    font: 2.05cqh MyriadPro-Regular;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.2cqh;\r\n}\r\n/* end new stuff */\r\n\r\n#optionsContainer1_series ul {\r\n    position: absolute;\r\n    list-style: none;\r\n\r\n    left: 25%;\r\n    top: 11.5%;\r\n\r\n    width: 70%;\r\n\r\n    font: 1.8cqh MyriadPro-Regular;\r\n}\r\n\r\n#optionsContainer2_series ul {\r\n    position: absolute;\r\n    list-style: none;\r\n\r\n    left: 30%;\r\n    top: 11.5%;\r\n\r\n    width: 60%;\r\n\r\n    font: 1.8cqh MyriadPro-Regular;}\r\n\r\n#optionsContainer3_series ul {\r\n    position: absolute;\r\n    list-style: none;\r\n\r\n    left: 27%;\r\n    top: 11.5%;\r\n\r\n    width: 68%;\r\n\r\n    font: 1.8cqh MyriadPro-Regular;\r\n}\r\n\r\n#optionsContainer4_series ul {\r\n    position: absolute;\r\n    list-style: none;\r\n\r\n    left: 27%;\r\n    top: 11.5%;\r\n\r\n    width: 70%;\r\n\r\n    font: 1.8cqh MyriadPro-Regular;\r\n}\r\n\r\nli {\r\n    padding-left: 0em;\r\n}\r\n\r\n#inputDiv1 ul li:before {\r\n    content: \"- \";\r\n}\r\n\r\n#inputDiv2 ul li:before {\r\n    content: \"- \";\r\n}\r\n\r\n#inputDiv3 ul li:before {\r\n    content: \"- \";\r\n}\r\n\r\n#inputDiv4 ul li:before {\r\n    content: \"- \";\r\n}\r\n\r\n#input1-SeriesSelection {\r\n    clip-path: polygon(0% 0%, 83.8% 0%, 98.9% 50%, 83.8% 100%, 0% 100%);\r\n}\r\n\r\n#input2-SeriesSelection {\r\n    clip-path: polygon(1.5% 0%, 86.3% 0%, 98.8% 50%, 86.3% 100%, 1.5% 100%, 14% 50%);\r\n}\r\n\r\n#input3-SeriesSelection {\r\n    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 12.9% 50%);\r\n}\r\n\r\n#input4-SeriesSelection {\r\n    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 12.9% 50%);\r\n}\r\n\r\n.input-SeriesSelection {\r\n    position: relative;\r\n    height: 100%;\r\n    width: 100%;\r\n    opacity: 0;\r\n    z-index: 2;\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n.inputImage {\r\n    position: absolute;\r\n\r\n    /* left: 0; */\r\n    right: 0;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    transform: scale(100%);\r\n\r\n    opacity: 1;\r\n    z-index: 4;\r\n\r\n    pointer-events: none;\r\n\r\n    transition: opacity 0.2s 0.3s ease-in-out;\r\n}\r\n\r\n.inputImage-Highlight {\r\n    position: absolute;\r\n\r\n    left: 0%;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    opacity: 0;\r\n    -moz-opacity: 0;\r\n    filter: alpha(opacity=0);\r\n    z-index: 5;\r\n\r\n    transition: opacity 0.2s 0.3s ease-in-out;\r\n}\r\n\r\n#base-car {\r\n    position: absolute;\r\n\r\n    left: 47%;\r\n    top: 47%;\r\n    transform: translate(-50%, -50%) rotate(1.2deg);\r\n\r\n    height: 80%;\r\n\r\n    z-index: 5;\r\n}\r\n\r\n#carbon-car {\r\n    position: absolute;\r\n\r\n    left: 55%;\r\n    top: 47%;\r\n    transform: translate(-50%, -50%) rotate(0.1deg);\r\n\r\n    height: 80%;\r\n\r\n    z-index: 5;\r\n}\r\n\r\n#liquid-carbon-car {\r\n    position: absolute;\r\n\r\n    left: 55%;\r\n    top: 47%;\r\n    transform: translate(-50%, -50%) rotate(0.3deg);\r\n\r\n    height: 80%;\r\n\r\n    z-index: 5;\r\n}\r\n\r\n#special-edition-car {\r\n    position: absolute;\r\n\r\n    left: 55%;\r\n    top: 47%;\r\n    transform: translate(-50%, -50%) rotate(0.3deg);\r\n\r\n    height: 80%;\r\n\r\n    z-index: 5;\r\n}\r\n\r\n.car {\r\n    background-color: transparent;\r\n}\r\n\r\n.car-hover {\r\n    animation: car-embiggen 1s forwards;\r\n}\r\n\r\n.car-endhover {\r\n    animation: car-emsmollen 0.4s forwards;\r\n}\r\n\r\n.details_header {\r\n    position: absolute;\r\n    \r\n    left: 58%;\r\n    top: 7.7%;\r\n\r\n    transform: translate(-50%);\r\n\r\n    text-transform: uppercase;\r\n\r\n    font: 1.2cqh MyriadPro-Regular;\r\n    letter-spacing: 0.05cqh;\r\n\r\n    color: white\r\n}\r\n\r\n@keyframes car-embiggen {\r\n    from {\r\n        height: 77%;\r\n    }\r\n    to {\r\n        height: 84%;\r\n    }\r\n}\r\n\r\n@keyframes car-emsmollen {\r\n    from {\r\n        height: 84%;\r\n    }\r\n    to {\r\n        height: 77%;\r\n    }\r\n}\r\n\r\n.black-background {\r\n    background-color: black;\r\n}\r\n\r\n.fadingOutImage1 {\r\n    animation-duration: 0.3s;\r\n    animation-name: fade-out1;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n.fadingOutImage2 {\r\n    animation-duration: 0.6s;\r\n    animation-name: fade-out2;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n.fadingOutImage3 {\r\n    animation-duration: 0.9s;\r\n    animation-name: fade-out3;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n.fadingOutImage4 {\r\n    animation-duration: 1.2s;\r\n    animation-name: fade-out4;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n@keyframes fade-in {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes remove-blocker {\r\n\r\n    0%,\r\n    99.99% {\r\n        pointer-events: all;\r\n    }\r\n\r\n    100% {\r\n        pointer-events: none;\r\n    }\r\n}\r\n\r\n@keyframes fade-out1 {\r\n\r\n    from {\r\n        opacity: 1\r\n    }\r\n\r\n    100% {\r\n        opacity: 0.001\r\n    }\r\n}\r\n\r\n@keyframes fade-out2 {\r\n\r\n    from,\r\n    50% {\r\n        opacity: 1\r\n    }\r\n\r\n    100% {\r\n        opacity: 0\r\n    }\r\n}\r\n\r\n@keyframes fade-out3 {\r\n\r\n    from,\r\n    66.666% {\r\n        opacity: 1\r\n    }\r\n\r\n    100% {\r\n        opacity: 0\r\n    }\r\n}\r\n\r\n@keyframes fade-out4 {\r\n\r\n    from,\r\n    75% {\r\n        opacity: 1\r\n    }\r\n\r\n    100% {\r\n        opacity: 0\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
